import {
  EntityType,
  NewsfeedType,
} from '@epicuro-next/data/engagement/engagement-models';
import { createAction, props } from '@ngrx/store';

/** Delete action */
export const deleteArticle = createAction(
  '[News Feed] Delete Article',
  props<{
    feedId: string;
    referenceId: string;
    referenceType: EntityType;
    newsfeedType: NewsfeedType;
  }>(),
);

/** Delete success action */
export const deleteArticleSuccess = createAction(
  '[News Feed] Delete Article Success',
  props<{
    feedId: string;
    referenceId: string;
    referenceType: EntityType;
    newsfeedType: NewsfeedType;
  }>(),
);

/** Delete fail action */
export const deleteArticleFail = createAction(
  '[News Feed] Delete Article Fail',
  props<{
    newsfeedType: NewsfeedType;
  }>(),
);

export const deleteArticlesBulk = createAction(
  '[News Feed] Delete Article Bulk',
  props<{ ids: string[] }>(),
);
